import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';

import 'bulma/css/bulma.min.css';

import { CellActivationStatus, CellValidationStatus, CellHelpStatus, CellHelpMessage, CellValidationResult, CellSubcomponentParameters } from './cellDto.ts';


function CellCheckbox(settings: CellSubcomponentParameters) {

  // Activating a CellCheckbox is a different operation than with other components.
  // We immediately call "save" and "close", which de-activates it again.
  useEffect(() => {
    if (settings.activationStatus != CellActivationStatus.Inactive) {
      if (!settings.isReadOnly) {
        settings.cellFunctions.save(settings.value ? false : true);
      }
      settings.cellFunctions.close();
    }
  }, [settings.activationStatus]);

  // The margin is compensation for the padding added in non-edit mode,
  // to keep the checkbox aligned in both modes.
  return (
    <div className="icon" style={{ margin: ".375rem 1rem" }}>
      <FontAwesomeIcon icon={settings.value ? faCheckSquare : faSquare} />
    </div>
  );
}


function CellCheckboxValue(settings: { value: boolean }) {
  return (
    <span className="icon">
      <FontAwesomeIcon icon={settings.value ? faCheckSquare : faSquare} />
    </span>
  );
}


export { CellCheckbox, CellCheckboxValue }
